<template>
  <v-data-table
    :headers="headers"
    :items="purchaseConditions"
    item-key="id"
    :items-per-page="10"
    :sort-by="['ref', 'billingUnit', 'incoTerm', 'pcbPackaging', 'netPrice', 'beginDate']"
    multi-sort
    :group-by="groupProperty"
    :footer-props="{
      itemsPerPageText: $t('page.selection.linePerPage'),
      pageText: '{0}-{1}/{2}',
      itemsPerPageOptions: [5, 10, 20, -1],
      itemsPerPageAllText: $t('page.selection.allLines')
    }"
  >
    <template v-slot:[`group.header`]="{ group }">
      <group-header :group-key="group" class="light-blue lighten-5" />
    </template>

    <template v-slot:item="row">
      <row :purchase-condition="row.item" :duplicates-mod="duplicatesMod" @click.native="rowClick(row.item)">
        <template v-slot:state-column>
          <span role="checkbox">
            <v-icon :color="color(row.item)">
              {{ icon(row.item) }}
            </v-icon>
          </span>
        </template>
      </row>
    </template>
  </v-data-table>
</template>

<script lang="ts">
import Vue from 'vue';
import { PurchaseCondition } from '@/models/purchase-condition/purchase-condition';
import { Status } from '@/models/purchase-condition/selection/status-enum';
import {
  duplicatesSelectionTableHeaders,
  selectionTableHeaders
} from '@/components/selection/selection-tables-headers';
import Row from '@/components/selection/selection-row.vue';
import GroupHeader from '@/components/selection/selection-table-group-header.vue';

type GroupProperty = 'duplicateKey' | null;

export default Vue.extend({
  name: 'SelectionTable',
  components: {
    Row,
    GroupHeader
  },
  props: {
    duplicatesMod: {
      type: Boolean,
      default: false
    },
    purchaseConditions: {
      type: Array as () => PurchaseCondition[],
      default: () => []
    },
    currentSelection: {
      type: Array as () => string[],
      default: () => []
    },
    currentUnselection: {
      type: Array as () => string[],
      default: () => []
    },
    rowClick: {
      type: Function,
      default: () => () => {}
    }
  },
  computed: {
    headers() {
      return this.duplicatesMod ? duplicatesSelectionTableHeaders : selectionTableHeaders;
    },
    groupProperty(): GroupProperty {
      return this.duplicatesMod ? 'duplicateKey' : null;
    }
  },
  methods: {
    color(purchaseCondition: PurchaseCondition): string {
      if (this.currentSelection.includes(purchaseCondition.id)) {
        return 'success';
      }
      if (this.currentUnselection.includes(purchaseCondition.id)) {
        return 'warning';
      }
      if (this.isSelected(purchaseCondition)) {
        return 'info';
      }
      return '';
    },
    icon(purchaseCondition: PurchaseCondition): string {
      if (this.currentUnselection.includes(purchaseCondition.id)) {
        return 'mdi-minus-box';
      }
      if (this.currentSelection.includes(purchaseCondition.id)) {
        return 'mdi-plus-box';
      }
      if (this.isSelected(purchaseCondition)) {
        return 'mdi-checkbox-marked';
      }
      return 'mdi-checkbox-blank-outline';
    },
    isSelected(purchaseCondition: PurchaseCondition): boolean {
      return purchaseCondition.selection != null && purchaseCondition.selection.status === Status.SELECTED;
    }
  }
});
</script>
